import type { ObjectOrganization } from '@/domain';
import { logos } from '@/lib/helpers/logos';

import styles from './ProfileCompany.module.css';

type ProfileCompanyProps = {
    organisation?: ObjectOrganization;
};

export const ProfileCompany = ({ organisation }: ProfileCompanyProps) => {
    const logo = organisation?.importId ? logos[organisation?.importId] : null;
    return (
        <div data-testid="companyProfile">
            {logo ? (
                <img className={styles.logo} alt={organisation?.name ?? ''} src={`https://images.finncdn.no/dynamic/142w/logo/${logo}`} />
            ) : null}
        </div>
    );
};
